import { MappedProduct } from '@/fo/util/map-product-data';

export interface ArticlePostTag {
  id: string;
  name: string;
  color?: string;
  href?: string | null;
}

export interface ArticlePostAuthor {
  id: string;
  name: string;
  description?: string | null;
  image: string;
  url: string;
}

export enum ImagePosition {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom'
}

export interface ArticlePostContent {
  id: string;
  title?: string | null;
  text?: string | null;
  image?: string | null;
  imagePosition?: ImagePosition | null;
  imageAlt?: string | null;
  imageLink?: string | null;
  products?: MappedProduct[];
  video?: string | null;
  videoImage?: string | null;
}

export interface ArticlePost {
  id: string;
  title: string;
  slug: string;
  image: string;
  topics: ArticlePostTag[];
  category?: ArticlePostTag | null;
  authors: ArticlePostAuthor[];
  description?: string | null;
  content: ArticlePostContent[];
}

export interface TableOfContentsItem {
  title: string;
  id: string;
}
